export class InvalidParamsSharedError extends Error {
  static create(errorMessage) {
    return new InvalidParamsSharedError(errorMessage)
  }
}
